<template>
    <div style="position: relative">
        <div id="middle">
            <i v-show="isExistence" class="el-icon-arrow-left pointLeft" @click="reduce"></i>
            <i v-show="isExistence" class="el-icon-arrow-right pointRight" @click="add"></i>
            <img :src="bigPic"></img>
            <span v-if="isExistence" class="Page">{{checkedPic + 1}}/{{changePicturesMap.get(checked).length}}</span>
        </div>

        <div id="bottom">
            <ul class="navAlbum" v-if="state === 0">
                <li v-if="isExistence && changePicturesMap.get(0).length > 0" :class="checked === 0 ? 'checked' : ''" style="width: 120px" @click="pointLi(0)">全部 ({{changePicturesMap.get(0).length}})</li>
                <li v-if="isExistence && changePicturesMap.get(1).length > 0" :class="checked === 1 ? 'checked' : ''" style="width: 120px" @click="pointLi(1)">外观 ({{changePicturesMap.get(1).length}})</li>
                <li v-if="isExistence && changePicturesMap.get(2).length > 0" :class="checked === 2 ? 'checked' : ''" style="width: 120px" @click="pointLi(2)">房间 ({{changePicturesMap.get(2).length}})</li>
                <li v-if="isExistence && changePicturesMap.get(3).length > 0" :class="checked === 3 ? 'checked' : ''" style="width: 120px" @click="pointLi(3)">公共 ({{changePicturesMap.get(3).length}})</li>
                <li v-if="isExistence && changePicturesMap.get(4).length > 0" :class="checked === 4 ? 'checked' : ''" style="width: 120px" @click="pointLi(4)">其他 ({{changePicturesMap.get(4).length}})</li>
            </ul>
        </div>

        <div id="photoWall" class="hiddenScrollbar" v-if="isExistence">
            <div class="picKuai"  :class="checkedPic === index ? 'checkedPic' : ''" v-for="(pic,index) in changePicturesMap.get(checked)" :key="index">
                <img :src="pic"  @click="checkedPicPoint(pic,index)"></img>
            </div>
        </div>
    </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具 js，第三方插件 js，json 文件，图片文件等等）
// 例如：import  《组件名称》  from '《组件路径》 ';
import {pictureMinxin} from "@/components/minxins/picture";

export default {
    name: "ProductPicture",
    data() {
        // 这里存放数据
        return {
        }
    },
    mixins: [pictureMinxin]
}
</script>

<style scoped lang="scss">
#middle {
    position: relative;
    width: 500px;
    border-radius: 15px;
    .Page {
        width: 80px;
        height: 26px;
        border-radius: 13px;
        background: rgba(0,0,0,.8);
        position: absolute;
        bottom: 10px;
        left: 50%;
        margin-left: -40px;
        text-align: center;
        line-height: 26px;
        color: #fff;
    }
    >img {
        width: 100%;
        height: -webkit-fill-available;
        border-radius: 15px;
        object-fit: cover;
    }
    .pointLeft {
        position: absolute;
        top: 45%;
        display: flex;
        width: 30px;
        height: 30px;
        background: white;
        border-radius: 50%;
        justify-content: center;
        align-items: center;
        left: 3px;
        font-size: 16px;
        font-weight: 700;
        &:hover {
            cursor: pointer;
        }
    }

    .pointRight {
        position: absolute;
        top: 45%;
        display: flex;
        width: 30px;
        height: 30px;
        background: white;
        border-radius: 50%;
        justify-content: center;
        align-items: center;
        right: 3px;
        font-size: 16px;
        font-weight: 700;
        &:hover {
            cursor: pointer;
        }
    }
}
#bottom {
    .navAlbum {
        overflow: hidden;
        height: 100%;
        margin-left: 0;
        >li {
            float: left;
            height: 36px;
            line-height: 36px;
            padding: 0 16px;
            text-align: center;
            font-size: 14px;
            border: 1px solid #ededed;
            border-radius: 18px;
            color: #5c5c5c;
            margin: 10px 10px 0 0;
            cursor: pointer;
            position: relative;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
            -webkit-backface-visibility: hidden;
            backface-visibility: hidden;
            -webkit-transform: translateZ(0);
            transform: translateZ(0);
        }
    }
    .checked {
        border: 0;
        background: #4db46a;
        color: white !important;
    }
}

#photoWall {
    padding-top: 10px;
    display: -webkit-inline-box;
    width: 100%;
    overflow-x: auto;
    .picKuai {
        width: 120px;
        height: 120px;
        overflow-y: clip;
        margin-right: 5px;
        >img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            &:hover {
                cursor: pointer;
            }
        }
    }
    .checkedPic {
        border: 2px solid #4db46a;
        box-shadow: 0 0 5px #4db46a;
    }
}

</style>